// Shared lookup table used by both checkout tracking and product-page tracking.
const ECOMMERCE_PRODUCTS = [
    {
        productId: "1",
        productSKU: "rcb",
        productName: "Real Cookie Banner",
        categoryName: "WordPress plugin",
        paths: [
            "/wordpress-real-cookie-banner/",
            "/de/wordpress-real-cookie-banner/"
        ]
    },
    {
        productId: "2",
        productSKU: "rml",
        productName: "Real Media Library",
        categoryName: "WordPress plugin",
        paths: [
            "/wordpress-real-media-library/",
            "/de/wordpress-real-media-library/"
        ]
    },
    {
        productId: "3",
        productSKU: "rpm",
        productName: "Real Physical Media",
        categoryName: "WordPress plugin",
        paths: [
            "/wordpress-real-physical-media/",
            "/de/wordpress-real-physical-media/"
        ]
    },
    {
        productId: "4",
        productSKU: "rcm",
        productName: "Real Category Management",
        categoryName: "WordPress plugin",
        paths: [
            "/wordpress-real-category-management/",
            "/de/wordpress-real-category-management/"
        ]
    },
    {
        productId: "5",
        productSKU: "rtg",
        productName: "Real Thumbnail Generator",
        categoryName: "WordPress plugin",
        paths: [
            "/wordpress-real-thumbnail-generator/",
            "/de/wordpress-real-thumbnail-generator/"
        ]
    }
];
function normalizePathname(pathname) {
    if (!pathname || pathname === "/") {
        return "/";
    }
    return pathname.endsWith("/") ? pathname : `${pathname}/`;
}
// Resolve the configured ecommerce product by landing-page URL path.
function resolveEcommerceProductByPath(pathname) {
    const normalizedPathname = normalizePathname(pathname);
    return ECOMMERCE_PRODUCTS.find(({ paths })=>paths.indexOf(normalizedPathname) > -1);
}
// Resolve the configured ecommerce product by backend product id.
function resolveEcommerceProductById(productId) {
    return ECOMMERCE_PRODUCTS.find((entry)=>entry.productId === String(productId));
}
export { ECOMMERCE_PRODUCTS, normalizePathname, resolveEcommerceProductById, resolveEcommerceProductByPath };
